import { Typography, Grid } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { CustomerInterface } from "../../Objects/Customer";

export interface MemberValidityDateProps {
    customerData: CustomerInterface
}

const MemberValidityDate: React.FC<MemberValidityDateProps> = ({
    customerData
}) => {
    return (
        <>
            {customerData.validity_date &&
                <Grid container>
                    <Grid item xs={12}>
                        <Typography variant="caption" sx={{color: "#333399"}}>有効期限</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="body1">{format(new Date(customerData.validity_date), "yyyy年MM月dd日")}</Typography>
                    </Grid>
                </Grid>
            }
        </>
    );
}

export default MemberValidityDate